import { DSModal } from "@components/design-system/organisms";
import React, { useState } from "react";

import { TemplateModalList } from "../components/templates/TemplateModalList";
import { TemplateSelectProvider } from "../context/templateSelectContext";

const withTemplatesMessageModal = (Component) =>
  function TemplatesMessageModalWrappedComponent(props) {
    const [
      shouldShowTemplateSelectModal,
      setShouldShowTemplateSelectModal,
    ] = useState(false);
    const [selectedTemplateUuid, setSelectedTemplateUuid] =
      useState(null);
    const [
      uuidOfNoteToOverwriteWithTemplate,
      setUuidOfNoteToOverwriteWithTemplate,
    ] = useState(null);

    return (
      <TemplateSelectProvider
        value={{
          setShouldShowTemplateSelectModal,
          selectedTemplateUuid,
          setSelectedTemplateUuid,
          uuidOfNoteToOverwriteWithTemplate,
          setUuidOfNoteToOverwriteWithTemplate,
        }}
      >
        <DSModal
          isOpen={shouldShowTemplateSelectModal}
          onClose={() => setShouldShowTemplateSelectModal(false)}
          title="Select a template"
          dataTestId="templates-select-modal"
          actions={[
            {
              label: "Close",
              variant: "cancel",
              onClick: () => setShouldShowTemplateSelectModal(false),
            },
          ]}
        >
          <p className="mb-2">
            Select an option below to apply this template to the note.
          </p>
          <p className="mb-3 font-semibold text-red-500">
            NOTE: This will overwrite any changes you have made to the
            existing note.
          </p>
          <div className="h-96 overflow-y-auto">
            <TemplateModalList />
          </div>
        </DSModal>
        <Component {...props} />
      </TemplateSelectProvider>
    );
  };
export default withTemplatesMessageModal;
